export default {
  //バリデーション
  SUBMIT_ERROR_TITLE: "Error / 错误",
  VALIDATION_EMPTY_MAIL_ADDRESS: "请输入电子邮件地址。",
  VALIDATION_INVALID_ADDRESS: "电子邮件地址格式不正确。",
  VALIDATION_EMPTY_PASSWORD: "请输入密码。",
  VALIDATION_INVALID_PASSWORD: "请输入包含至少8个半角英文字母和数字组合的密码。",
  VALIDATION_UNMATCH_PASSWORD: "密码不匹配。请重新输入。",
};
